import i18n from '@/utils/i18n';
import React from 'react';
import SubscriptionsIcon from '@assets/icons/subscriptions.svg';
import { AlertKeys, useUserSettingsContext } from '@/contexts/user-context';
import { APP_ROUTES, ORDER_ROUTES } from '@/navigators/routes';
import { AppContainerStackParams } from '@/navigators/types';
import { ICON_BUTTON_HIT_SLOP } from './navigation-header-content';
import { StackNavigationProp } from '@react-navigation/stack';
import { TooltipContainer } from './tooltip-container';
import { TooltipPosition } from '@/enums';
import { TouchableOpacity } from 'react-native';
import { useDynamicConfigValue } from '@/hooks/use-dynamic-config-value';
import { useNavigation } from '@react-navigation/native';
import { useTheme } from '@/contexts/theme-context';

type Navigation = StackNavigationProp<
  AppContainerStackParams,
  ORDER_ROUTES.Subscriptions
>;

export const SubscriptionButton: React.FC = () => {
  const theme = useTheme();
  const { navigate } = useNavigation<Navigation>();
  const { alertsSeen, setAlertSeen } = useUserSettingsContext();
  const subscriptionsEnabled = useDynamicConfigValue(
    'item_subscriptions_enabled',
  );
  if (!subscriptionsEnabled) {
    return null;
  }
  const navigateToSubscriptionsScreen = () => {
    navigate(APP_ROUTES.Orders, {
      screen: ORDER_ROUTES.Subscriptions,
    });
  };
  return (
    <TooltipContainer
      content={i18n.t('subscriptions.tooltip')}
      onClose={() => {
        setAlertSeen(AlertKeys.SubscriptionButton);
      }}
      position={TooltipPosition.Right}
      visible={!alertsSeen[AlertKeys.SubscriptionButton]}
    >
      <TouchableOpacity
        hitSlop={ICON_BUTTON_HIT_SLOP}
        onPress={navigateToSubscriptionsScreen}
        testID="subscription-button"
      >
        <SubscriptionsIcon stroke={theme.sk.color.icon.primary} />
      </TouchableOpacity>
    </TooltipContainer>
  );
};
